import JoinOrEditButton from 'club/joinButton/JoinOrEditButton';

import ClubImage from './ClubImage';

const Club = (props) => {
  const { club } = props;

  return (
    <div className="c7-club-list__item">
      <div className="c7-club-list__item__image">
        <ClubImage club={club} />
      </div>

      <div className="c7-club-list__item__content">
        <h2>{club.title}</h2>
        <div
          dangerouslySetInnerHTML={{
            __html: club.content
          }}
        />
        <JoinOrEditButton club={club} />
      </div>
    </div>
  );
};

export default Club;
